import EA from '../helpers/init';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from '../plugins/SplitText';

gsap.registerPlugin(ScrollTrigger);

export default EA.Methods.animIntro = ($this) => {
    gsap.registerPlugin(SplitText);
    
    const header = document.querySelector('.header');
    const fadeInEls = $this.querySelectorAll('.fade-in-bot-anim');
    const text = $this.querySelectorAll('.js-anim-text');
    const textParent = new SplitText(text, { type: 'lines', linesClass: 'overflow text-parent' });
    const textLines = $this.querySelectorAll('.text-parent');
    const textChars = new SplitText(textLines, { type: 'lines'});

    const tl = gsap.timeline();

    gsap.config({ nullTargetWarn: false });

    document.fonts.ready.then(() => {
        tl.from(header, {
            y: -100,
            duration: 0.8,
            alpha: 0,
            ease: 'power3.out',
            clearProps: 'transform,opacity',
        }, '<0.6')
            .from(textChars.lines, {
                yPercent: 300,
                stagger: 0.1,
                duration: 0.6,
                ease: 'power4.out',
                onComplete: () => {
                    window.addEventListener('resize', () => {
                        textChars.revert();
                        textParent.revert();
                    });
                }
            })
            .from(fadeInEls, {
                y: 70,
                duration: 0.75,
                alpha: 0,
                stagger: 0.35,
                ease: 'power3.out',
                clearProps: 'transform,opacity',
            }, '=0.1');

        setTimeout(() => tl.play(), 100);

        addEventListener('resize', () => {
            tl.progress(1).kill();
        });
    });
};
